<template>
  <div class="md:flex md:gap-4 md:between divide-grey-70 <md:divide-y" :class="brandClasses">
    <base-collapse
      v-for="({ title, children }, key) in columns"
      :key
      class="w-full md:py-8"
      class-content="md:max-h-screen children:md:visible children:md:p-1 children:md:-m-1 md:rows-[1fr]"
      class-toggle="w-full md:hidden"
      @expand="$gtm.push('footer.onClickMobileFooterColumn', `Column ${key + 1}`)"
    >
      <template #toggle="{ expanded }">
        <span class="flex items-center between <md:p-4 subtitle-4 ">
          {{ title }}
          <vf-icon
            class="md:hidden"
            :dir="expanded ? icons.expanded.direction : icons.collapsed.direction"
            :name="expanded ? icons.expanded.icon : icons.collapsed.icon"
            :size="icons.size"
          />
        </span>
      </template>

      <h2 class="<md:hidden subtitle-4 ">
        {{ title }}
      </h2>

      <div class="<md:px-4 <md:pb-4">
        <ul class="text-sm md:mt-4 space-y-4 ">
          <li v-for="(child, j) in children" :key="j" class="space-y-4">
            <lazy-cms-section
              :key="child.id"
              :section="{ name: child.id, items: [{ ...child, footerItemL1: `Column ${key + 1}` }] }"
            />
          </li>
        </ul>
      </div>
    </base-collapse>
  </div>
</template>

<script lang="ts" setup>
const { brandClasses, icons } = useAppConfig().components.vf.footer.columns

const { getFooter } = useCms()

const cmsFooter = await getFooter()

const columns = computed(() => cmsFooter?.columns || [])
</script>
